module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/~/sockjs-client/lib/transport/browser/eventsource.js
// module id = 8cgK
// module chunks = 5